function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 4.667a2 2 0 100 4 2 2 0 000-4zm5.333-2h-1.6a.594.594 0 01-.526-.38l-.414-1.24a.594.594 0 00-.526-.38H4.733c-.22 0-.457.17-.526.38l-.414 1.24a.594.594 0 01-.526.38h-1.6C.933 2.667.333 3.267.333 4v6c0 .734.6 1.334 1.334 1.334h10.666c.734 0 1.334-.6 1.334-1.334V4c0-.733-.6-1.333-1.334-1.333zM7 10a3.333 3.333 0 110-6.666A3.333 3.333 0 017 10zm4.867-5.067a.467.467 0 110-.933.467.467 0 010 .933z",
  fill: "#BCBCBC"
});

var SvgCameraIcon = function SvgCameraIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 12,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCameraIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera-icon.0dd8ceb2.svg";
export { ForwardRef as ReactComponent };